(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gh-shelf"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const grid = document.getElementById('gh-shelf-grid');
    if (!grid) return;
    const chips = document.querySelectorAll('#gh-shelf-filters .chip');
    if (!chips.length) return;

    chips.forEach((chip) => {
      chip.addEventListener('click', () => {
        chips.forEach((c) => {
          c.classList.toggle('active', c === chip);
          c.setAttribute('aria-selected', c === chip ? 'true' : 'false');
        });
        const sub = chip.dataset.sub || 'all';
        grid.querySelectorAll('.pcard').forEach((card) => {
          card.hidden = sub !== 'all' && card.dataset.sub !== sub;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
